export default __webpack_public_path__ + "static/media/perugbc2.1c9f3666.jpg";